import { MultipleChoiceExamIllustration } from '../../../../../assets/illustrations';
import { MultipleChoiceExamDetail } from '../../../../../store/exam/types';
import { setExamRulesModal } from '../../../../../store/exam/slice';
import { ArrowRightIcon } from '../../../../../assets/icons/common';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import { useDispatch } from '../../../../../store/store';
import Spinner from '../../../../../components/Spinner';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';

interface Props {
    action: string | null;
    startExam: () => void;
    isCameraActive: boolean;
    isFetchingQuestions: boolean;
    detail: MultipleChoiceExamDetail | null;
};

function ExamDetail(props: Props) {
    const dispatch = useDispatch();

    const {
        action,
        detail,
        startExam,
        isCameraActive,
        isFetchingQuestions,
    } = props;

    return (
        <MotionWrapper className={styles.wrapper}>
            <MultipleChoiceExamIllustration />
            {!detail ? <Spinner /> : (
                <>
                    <span className={styles.title}>Press the start button when you're ready</span>
                    <span className={styles.description}>It takes <b>{detail.time} minutes</b> to complete the exam</span>
                    {!isCameraActive && <span className={styles.cameraAccess}>Please enable your camera access</span>}
                </>
            )}
            <Button
                type='Primary'
                onClick={startExam}
                className={styles.CTA}
                loading={isFetchingQuestions}
                disabled={!detail || !isCameraActive}
                text={action === 'resume' ? 'Resume the exam' : 'Start the exam'}
            />
            <div className={styles.extra}>
                <span className={styles.extra_text}>Please review exam rules before starting the exam</span>
                <div
                    className={styles.extra_btn}
                    onClick={() => dispatch(setExamRulesModal(true))}
                >
                    <span>Exams rules</span>
                    <ArrowRightIcon />
                </div>
            </div>
        </MotionWrapper>
    )
};

export default ExamDetail;
